import React, { Component } from 'react'
import './css.css';

class Roadmap extends Component {
   
    render(){
        console.log(this.props.update) 
        return ( 
            <div>
                <div id="bows_flyer" className="text white">
                    <div id="bows_mainlabel">🔮 ROADMAP</div>
                    <div id="bows_sublabel">Community Curated</div>
                    <div className="bows_panel dark darkblue text white">
                        <div className="instructions_title light lightblue text white">🏰 PLATFORM</div>
                        <br></br><br></br>
                        🎪 Districts
                        <br></br>
                        <br></br>
                        🏆 1st Hackathon
                        <br></br>
                        <br></br>
                        🌋 HappyLand connection
                        <br></br>
                        <br></br><br></br>
                        <div className="instructions_title light lightblue text white">📙 MODULES</div>
                        <br></br><br></br>
                        🔑 Conditional Seller (sells strictly to groups)
                        <br></br><br></br>
                        🎁 Gifter Seller (Adds a gift to a sale)
                        <br></br><br></br>
                        📈 Auctions
                        <br></br><br></br>
                        For an updated list and to book the creation of a new module please refer to: https://discord.gg/F3Cqksx
                    </div>
                </div>
            </div>
        );
    }

}

export default Roadmap